import React, { Component } from "react";
import { Link } from "react-router-dom";
import logo from "../../../../assets/Logo.png";
import numberOfQualifiedLeads from "../../../../assets/number-of-qualified-leads.svg";
import emailChecker from "../../../common/utils/emailChecker";
import styled from "styled-components";

// Styled Components
const MainContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 100vh;
  background-color: rgb(248, 248, 248);
`;

const SubContainer = styled.div`
  display: flex;
  width: 80%;
  max-width: 1200px;
  background-color: #000040;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  overflow: hidden;
`;

const ContentWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px;
  background-color: rgb(255, 255, 255);

  @media (max-width: 768px) {
    display: none;
  }
`;

const SuccessMessage = styled(ContentWrapper)`
  width: 100%;
  min-height: fit-content;
  text-align: center;
  background-color: transparent;
  color: #2e7d32;
  font-weight: 500;
  padding: 16px;
  margin: 16px 0;
  border-radius: 8px;
  background-color: rgba(46, 125, 50, 0.1);

  @media (max-width: 768px) {
    display: flex;
  }
`;

const FormWrapper = styled.div`
  flex: 1;
  padding: 60px 40px;
  min-height: fit-content;
`;

const FormColumn = styled.div`
  max-width: 400px;
  margin: 0 auto;
`;

const Title = styled.h1`
  font-size: 32px;
  font-weight: 700;
  margin-bottom: 32px;
  color: rgb(255, 255, 255);
  display: flex;
  justify-content: center;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
`;

const FormInput = styled.input`
  padding: 14px 16px;
  margin-bottom: 16px;
  border: 1px solid #ff0000;
  border-radius: 8px;
  background-color: #000040;
  font-size: 16px;
  color : white;
  transition: border-color 0.3s, box-shadow 0.3s;

  &:focus {
    outline: none;
    border-color: red;
    box-shadow: 0 0 0 3px rgba(86, 41, 182, 0.1);
  }

  &::placeholder {
    color: white;
  }
`;

const ButtonSuccessLarge = styled.button`
  padding: 14px 16px;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  background-color: rgb(255, 0, 0);
  color: white;
  border: none;
  margin-top: 40px;

  &:hover {
    background-color: rgb(199, 0, 0);
    transform: translateY(-2px);
  }

  &:disabled {
    background-color: #9f9f9f;
    cursor: default;
    transform: none;
  }
`;

const FormFooterLink = styled.div`
  text-align: center;
  margin-top: 32px;
  font-size: 14px;

  a {
    color: rgb(255, 255, 255);
    font-weight: 500;

    &:hover {
      text-decoration: underline !important;
    }
  }
`;

const Logo = styled.img`
  width: 125px;
  margin-bottom: 40px;
`;

const IllustrationImage = styled.img`
  width: 300px;
  max-width: 100%;
`;

class ForgotPassword extends Component {
  state = {
    forgotPass: {
      email: "",
    },
    isEmailValid: false,
    isEmailSend: false,
  };

  handleEmailChange = (event) => {
    let forgotPass = { ...this.state.forgotPass };
    forgotPass.email = event.currentTarget.value;
    let isEmailValid = emailChecker(forgotPass.email);
    this.setState({ forgotPass });
    this.setState({ isEmailValid });
  };

  forgotPassFormSubmit = (event) => {
    try {
      event.preventDefault();
      this.props.propsToContainer(this.state.forgotPass);
      console.log(window.localStorage.getItem("isEmailSend"));
      this.setState({ isEmailSend: true });
      setTimeout(() => {
        if (!window.localStorage.getItem("isEmailSend")) {
          this.setState({ isEmailSend: false });
        }
      }, 2000);
    } catch (error) {
      console.log(error.response);
    }
  };

  render() {
    return (
      <React.Fragment>
        <MainContainer>
          <SubContainer>
            <ContentWrapper>
              <Logo src={logo} alt="logo" />
              <IllustrationImage
                className="chatBotSvg"
                src={numberOfQualifiedLeads}
                alt="Qualified Leads Illustration"
              />
            </ContentWrapper>
            <FormWrapper>
              <FormColumn>
                <Title>Reset Password</Title>
                <Form>
                  {!this.state.isEmailSend && (
                    <FormInput
                      type="email"
                      required
                      placeholder="E-mail address"
                      onChange={this.handleEmailChange}
                    />
                  )}

                  {!this.state.isEmailSend && (
                    <ButtonSuccessLarge
                      disabled={!this.state.isEmailValid}
                      onClick={this.forgotPassFormSubmit}
                    >
                      Reset Password
                    </ButtonSuccessLarge>
                  )}

                  {this.state.isEmailSend && (
                    <SuccessMessage>
                      Password reset link has been sent to your registered email
                    </SuccessMessage>
                  )}

                  <FormFooterLink>
                    <Link to="/login">Have Credentials? Log in from here!</Link>
                  </FormFooterLink>
                </Form>
              </FormColumn>
            </FormWrapper>
          </SubContainer>
        </MainContainer>
      </React.Fragment>
    );
  }
}

export default ForgotPassword;
